import { useStyles } from '@archipro-design/aria';
import type { ReactNode } from 'react';
import * as S from './PageLayout.style';

interface PageLayoutProps {
    children: ReactNode;
}

const PageLayout = ({ children }: PageLayoutProps) => {
    const { css } = useStyles();
    return <div className={css(S.Page)}>{children}</div>;
};

export default PageLayout;
